export function compareJersey(name, type) {

  if (name.toLowerCase().includes('colavita')) {
    return 'Colavita@2x';
  } else if (name.toLowerCase().includes('dna')) {
    return 'DNA@2x';
  } else if (name.toLowerCase().includes('levine')) {
    return 'LLG 2020@2x';
  } else if (name.toLowerCase().includes('wolfpack')) {
    return 'Wolpack@2x';
  } else if (name.toLowerCase().includes('automatic')) {
    return 'Automatic@2x';
  } else if (name.toLowerCase().includes('butcherbox')) {
    return 'BBX@2x';
  } else if (name.toLowerCase().includes('buddies')) {
    return 'BestBuddies@2x';
  } else if (name.toLowerCase().includes('bscg')) {
    return 'Guttenplan@2x';
  } else if (name.toLowerCase().includes('cs velo')) {
    return 'CSV@2x';
  } else if (name.toLowerCase().includes('crca')) {
    return 'Good Guys@2x';
  } else if (name.toLowerCase().includes('instafund')) {
    return 'INSTAFUND';
  } else if (name.toLowerCase().includes('l39ion')) {
    return 'legion@2x';
  } else if (name.toLowerCase().includes('levine')) {
    return 'LLG 2020@2x';
  } else if (name.toLowerCase().includes('nashville')) {
    return 'NLC@2x';
  } else if (name.toLowerCase().includes('primal')) {
    return 'Primal Audi@2x';
  } else if (name.toLowerCase().includes('robson')) {
    return 'Robson@2x';
  } else if (name.toLowerCase().includes('strike')) {
    return 'Strike@2x';
  } else if (name.toLowerCase().includes('united')) {
    return 'United@2x';
  } else if (name.toLowerCase().includes('voler')) {
    return 'Voler@2x';
  } else if (name.toLowerCase().includes('clif')) {
    return 'clif@2x';
  }


  else if (name.toLowerCase().includes('aminorip') && type === 'men') {
    return 'Aminorip Men@2x';
  } else if (name.toLowerCase().includes('aminorip') && type === 'women') {
    return 'Aminorip Wom@2x';
  }

  else {
    return ''
  }


}